import { AnimateOnScrolledTo } from '@web/components/AnimateOnScrolledTo'
import { DemoButton } from '@web/components/DemoButton'

export default function FooterSection() {
  return (
    <section className="bg-neutral-muted py-16 md:py-24 md:pt-0">
      <div className="flex flex-col mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <AnimateOnScrolledTo transition={{ duration: 0.4 }} className="flex flex-col items-center">
          <h2 className="mb-16 text-2xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
            Ready to understand your risks and build resilience?
          </h2>
        </AnimateOnScrolledTo>
        <AnimateOnScrolledTo
          transition={{ duration: 0.4, delay: 0.2 }}
          className="flex flex-col items-center"
        >
          <DemoButton />
        </AnimateOnScrolledTo>
      </div>
    </section>
  )
}
